import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { LayoutHelper } from 'olx-autos-landing-page';

import withTrack from 'HOCs/withTrack/withTrack';
import { addFilterPreference } from 'Actions/filtersPreferences';
import { updateLocation } from 'Actions/selectLocation';
import {
    getPopularLocationsLeftBar,
    getCurrentListingLocation } from 'Selectors/popularLocations';
import { getFiltersPreference } from 'Selectors/filtersPreferences';
import { FILTER_TOP_LOCATIONS } from 'Constants/locations';
import CollapsibleV2 from 'Components/CollapsibleV2/CollapsibleV2';
import css from './TopLocations.scss';
import { LOCATION_COMPLETE, FILTER, TYPE_TREE } from 'Constants/tracking';
import LocationGroup from './LocationGroup';
import withRouter from 'HOCs/withRouter';

export const TopLocations = ({
    intl,
    locations,
    currentLocation: { name },
    track,
    updateLocation,
    onLocationChange,
    onCollapsed
}) => {
    const locationText = useMemo(() => intl.formatMessage({ id: 'locations' }), [intl]);
    const onLocationClick = useCallback((_, location) => {
        track(LOCATION_COMPLETE, {
            place_selected_id: location.id,
            select_from: FILTER,
            location_type: TYPE_TREE,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });

        updateLocation(location.id);
        onLocationChange(location);
    }, [onLocationChange, track, updateLocation]);

    return (
        <CollapsibleV2
            className={ css.topLocations }
            titleClassName={ css.topLocations__title }
            title={ locationText }
            collapsedContent={ name }
            collapsedContentClassName={ css.topLocations__collapsed }
            onCollapsed={ onCollapsed }
            data-aut-id="collapsible_topLocations"
            isInitiallyOpen
        >
            <LocationGroup
                items={ locations }
                onSelect={ onLocationClick }
            />
        </CollapsibleV2>
    );
};

TopLocations.propTypes = {
    locations: PropTypes.array.isRequired,
    currentLocation: PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number
    }),
    track: PropTypes.func,
    onCollapsed: PropTypes.func,
    updateLocation: PropTypes.func,
    onLocationChange: PropTypes.func,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

TopLocations.defaultProps = {
    collapsed: false,
    onCollapsed: () => {},
    updateLocation: () => {},
    track: () => {},
    currentLocation: {
        name: '',
        id: 0
    },
    onLocationChange: () => {},
    type: ''
};

const mapStateToProps = (state, ownProps) => {
    const params = {
        categoryId: ownProps.params.categoryID,
        locationId: ownProps.params.geoID,
        search: ownProps.params.text,
        params: ownProps.location.query,
        constructionStatus: ownProps.params.constructionStatus,
        type: ownProps.type || ''
    };

    return {
        locations: getPopularLocationsLeftBar(state, params),
        currentLocation: getCurrentListingLocation(state, params),
        collapsed: getFiltersPreference(state, { key: FILTER_TOP_LOCATIONS })
    };
};

const mapDispatchToProps = dispatch => ({
    onCollapsed: collapsed => dispatch(addFilterPreference({ [FILTER_TOP_LOCATIONS]: collapsed })),
    updateLocation: id => dispatch(updateLocation({ id }))
});

export default compose(
    withRouter,
    withTrack,
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(TopLocations);
